import assetsAPI from 'services/assets'

interface MaintenanceResponse {
  maintenance: {
    /*
     * underMaintenance property it's not updated in real time
     * so use downTime dates instead
     */
    underMaintenance: boolean
    downTime: {
      startDateTime: string
      stopDateTime: string
      notificationMessage: string
      downTimeMessage: string
    }
  }
}

export const getMaintenance = async (): Promise<
  MaintenanceResponse['maintenance']
> => {
  const response = await assetsAPI.getMaintenanceStatus()

  return (response as MaintenanceResponse).maintenance
}
